import "@/helpers/turbo"
import "@/styles/home.scss"

import { application } from "../helpers/stimulus"

import { setupSearchBar } from "@/components/search_bar"

import CarouselController from "../controllers/carousel_controller"
import TabsController from "../controllers/tabs_controller"

const setupStimulus = (): void => {
  application.register("carousel", CarouselController)
  application.register("tabs", TabsController)
}

setupSearchBar()
setupStimulus()
